module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "100vh"
    }
  }, [_c('div', {
    staticClass: "col-3",
    attrs: {
      "id": "app"
    }
  }, [_c('div', [_c('div', {
    staticClass: "mb-2"
  }, [_c('button', {
    staticClass: "btn btn-outline-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addTable
    }
  }, [_vm._v("Add table")]), _vm._v(" "), _c('div', {
    staticClass: "d-inline-block imageuploader"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.previewImage
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-outline-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_vm._v("Upload image")])])]), _vm._v(" "), (!_vm.selectedTable) ? _c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.tables), function(table, n) {
    return _c('a', {
      key: n,
      staticClass: "list-group-item list-group-item-action flex-column align-items-start",
      class: {
        'active': table.hovered
      },
      attrs: {
        "href": "#"
      }
    }, [_c('div', {
      staticClass: "d-flex w-100 justify-content-between"
    }, [_c('h5', {
      staticClass: "mb-1"
    }, [_vm._v(_vm._s(table.title))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(table.size))])])])
  }), 0) : _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTable.title),
      expression: "selectedTable.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.selectedTable.title)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedTable, "title", $event.target.value)
      }, _vm.onChange]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Size")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTable.size),
      expression: "selectedTable.size"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "1000",
      "placeholder": "Size"
    },
    domProps: {
      "value": (_vm.selectedTable.size)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedTable, "size", $event.target.value)
      }, _vm.onChange]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTable.hasExtra),
      expression: "selectedTable.hasExtra"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox",
      "id": "customCheck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedTable.hasExtra) ? _vm._i(_vm.selectedTable.hasExtra, null) > -1 : (_vm.selectedTable.hasExtra)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectedTable.hasExtra,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedTable, "hasExtra", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedTable, "hasExtra", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedTable, "hasExtra", $$c)
        }
      }, _vm.onChange]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "customCheck1"
    }
  }, [_vm._v("Extra places")])])]), _vm._v(" "), (_vm.selectedTable.hasExtra) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Extra places")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTable.extraPlaces),
      expression: "selectedTable.extraPlaces"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "1000",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.selectedTable.extraPlaces)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedTable, "extraPlaces", $event.target.value)
      }, _vm.onChange]
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Priority")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTable.priority),
      expression: "selectedTable.priority"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "1000",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.selectedTable.priority)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedTable, "priority", $event.target.value)
      }, _vm.onChange]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTable.avaliable),
      expression: "selectedTable.avaliable"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "type": "checkbox",
      "id": "customCheck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectedTable.avaliable) ? _vm._i(_vm.selectedTable.avaliable, null) > -1 : (_vm.selectedTable.avaliable)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectedTable.avaliable,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.selectedTable, "avaliable", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.selectedTable, "avaliable", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.selectedTable, "avaliable", $$c)
        }
      }, _vm.onChange]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "customCheck2"
    }
  }, [_vm._v("Avaliable for booking")])])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.deleteTable(_vm.selectedTable)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-delete"
  }), _vm._v("\n          Delete table\n        ")])], 1)])]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-9"
  }, [_c('div', {
    attrs: {
      "id": "cc"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "c"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3506a296"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/ManageRoom.vue
// module id = 415
// module chunks = 4